import React__default from 'react';

const skeletonLoader = "_skeleton-loader_igt8w_1";
const styles = {
	skeletonLoader: skeletonLoader
};

const SkeletonLoader = (props) => {
  return React__default.createElement("div", { className: styles.skeletonLoader, "data-zds": true }, props.children);
};

export { SkeletonLoader };
//# sourceMappingURL=SkeletonLoader.es.js.map
